import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import passcode from "./passcode";

const modulePreloader = {
  actions,
  getters,
  mutations,

  modules: {
    passcode
  },

  namespaced: true,

  state: {
    showPreloader: true,
    percentProgress: 0
  }
};

export default modulePreloader;
